import api from '@/api';

export default {
  namespaced: true,

  state: {
    comments: [],
    error: [],
    replyTo: null
  },

  getters: {
    reverseComments: state => state.comments.reverse(),
  },

  mutations: {
    SET_COMMENTS(state, payload) {
      state.comments = payload;
    },
    SET_ERROR(state, payload) {
      state.error = payload;
    },
    SET_OPEN_COMMENT(state, id) {
      state.replyTo = id;
    }
  },

  actions: {
    async list({ state, commit }, props) {
      let url = `/collaboration/question/${props.questionId}/idea/${props.ideaId}/comments`;
      if (props.nested) {
        url = `${url}/relational`
      }

      let resp;

      try {
        resp = await api().get(url);
        // once we have comments
        commit('SET_COMMENTS', resp.data.data.comment);
      } catch (err) {
        // if we have no results, return an empty array
        const { response } = err;
        if (response.status === 404 && response.data.data.length == 0) {
          commit('SET_COMMENTS', []);
        } else {
          commit('SET_ERROR', response.data.error);
        }
      }
    },

    async addComment({ dispatch, commit }, comment) {
      const url = `/collaboration/question/${comment.questionId}/idea/${comment.ideaId}/comment`;
      let resp;

      const payload = {
        title: comment.title,
        description: comment.title,
        parent_id: comment.parentId,
      };


      try {
        resp = await api().post(url, { comment: payload });
        commit('SET_OPEN_COMMENT', null)
        dispatch('list', { ...comment, nested: true });
      } catch (err) {
        console.log(err);
        commit('SET_ERROR', err.response.data.error);
      }
    },

    async deleteComment({ commit }, {questionId,ideaId,commentId}) {
      let resp;


      try {
        resp = await api().delete(`/collaboration/question/${questionId}/idea/${ideaId}/comment/${commentId}`);
        return Promise.resolve(resp)
      } catch (err) {
        console.log(err);
        commit('SET_ERROR', err.response.data.error);
        return Promise.reject(err)
      }
    },

    resetState({ commit }) {
      commit('SET_COMMENTS', []);
    },

    setOpenComment({ commit }, id) {
      commit('SET_OPEN_COMMENT', id);
    }
  },
};
